import type { ReactNode } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "./pages/Login.js";
import KidLayout from "./pages/kid/KidLayout.js";
import Home from "./pages/kid/Home.js";
import Goals from "./pages/kid/Goals.js";
import GoalDetail from "./pages/kid/GoalDetail.js";
import Allowance from "./pages/kid/Allowance.js";
import History from "./pages/kid/History.js";
import Learn from "./pages/kid/Learn.js";
import TransferRequest from "./pages/kid/TransferRequest.js";
import ParentLayout from "./pages/parent/ParentLayout.js";
import Dashboard from "./pages/parent/Dashboard.js";
import Activity from "./pages/parent/Activity.js";
import Settings from "./pages/parent/Settings.js";
import KidPreview from "./pages/parent/KidPreview.js";
import { UserProvider, useUser } from "./auth/UserContext.js";

function RoleGate({ allow, children }: { allow: "kid" | "parent"; children: ReactNode }) {
  const { bundle, loading } = useUser();
  if (loading)
    return (
      <div className="center" style={{ padding: 80 }}>
        Loading…
      </div>
    );
  if (!bundle) return <Navigate to="/login" replace />;
  if (bundle.user.role !== allow) return <Navigate to={`/${bundle.user.role}`} replace />;
  return <>{children}</>;
}

function RoleRedirect() {
  const { bundle, loading } = useUser();
  if (loading)
    return (
      <div className="center" style={{ padding: 80 }}>
        Loading…
      </div>
    );
  if (!bundle) return <Navigate to="/login" replace />;
  return <Navigate to={`/${bundle.user.role}`} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/kid"
            element={
              <RoleGate allow="kid">
                <KidLayout />
              </RoleGate>
            }
          >
            <Route index element={<Navigate to="home" replace />} />
            <Route path="home" element={<Home />} />
            <Route path="goals" element={<Goals />} />
            <Route path="goals/:goalId" element={<GoalDetail />} />
            <Route path="allowance" element={<Allowance />} />
            <Route path="history" element={<History />} />
            <Route path="send" element={<TransferRequest />} />
            <Route path="learn" element={<Learn />} />
          </Route>
          <Route
            path="/parent"
            element={
              <RoleGate allow="parent">
                <ParentLayout />
              </RoleGate>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="activity" element={<Activity />} />
            <Route path="settings" element={<Settings />} />
            <Route path="kids/:kidId" element={<KidPreview />} />
          </Route>
          <Route path="*" element={<RoleRedirect />} />
        </Routes>
      </UserProvider>
    </BrowserRouter>
  );
}
